import { StyleOptionInterface } from "@/interface/business/digital-menu.interface";

export default class StyleOption implements StyleOptionInterface {
  family: string = "";
  size: string = "";
  color: string = "";

  constructor(data?) {
    this.family = data?.family || "";
    this.size = data?.size || "1.8";
    this.color = data?.color || "#2D415A";
  }
}
